import { ICoordinates } from 'libs/types/map/mapTypes';
import { getMiddle } from 'libs/utils/gpx/boundariesUtils';
import { IXY } from 'react-give-me-map/dist/utils/map/mapTypes';

const gpxParser = require('gpxparser');

export interface IStravaGPX {
    metadata: {
        name: string;
        desc: string;
        time: string;
        author: unknown;
    };
    routes: unknown[];
    tracks: {
        distance: {
            total: number;
        };
        elevation: {
            max: number;
            min: number;
            pos: number;
            neg: number;
            avg: number;
        };
        name: string;
        points: IStravaGPXPoint[];
    };
}

export interface IStravaGPXPoint {
    ele: number;
    lat: number;
    lon: number;
    time: Date;
}

export function parseStravaGPX(content: string): ICoordinates[] {
    const stravaGPX = new gpxParser();
    stravaGPX.parse(content);
    console.log('Parsed', stravaGPX);
    if (!stravaGPX.tracks[0]?.points) {
        return [];
    }

    const coordinates = (stravaGPX as IStravaGPX).tracks[0]?.points?.map((point) => {
        const p = point as IStravaGPXPoint;
        return {
            lat: p.lat,
            lng: p.lon
        };
    });
    return coordinates;
}

export interface ICoordinatesBoundaries {
    center: ICoordinates;
    topLeft: ICoordinates;
    bottomRight: ICoordinates;
    start: ICoordinates;
}

export function getCoordinatesBoundaries(coordinates: ICoordinates[]): ICoordinatesBoundaries {
    const center: ICoordinates = {
        lat: getMiddle('lat', coordinates),
        lng: getMiddle('lng', coordinates)
    };
    let topLeft: ICoordinates = { lat: -Infinity, lng: Infinity };
    let bottomRight: ICoordinates = { lat: Infinity, lng: -Infinity };
    const start: ICoordinates = { lat: coordinates[0].lat, lng: coordinates[0].lng };
    for (const a of coordinates) {
        if (topLeft.lng > a.lng) {
            topLeft = {
                ...topLeft,
                lng: a.lng
            };
        }
        if (topLeft.lat < a.lat) {
            topLeft = {
                ...topLeft,
                lat: a.lat
            };
        }
        if (bottomRight.lng < a.lng) {
            bottomRight = {
                ...bottomRight,
                lng: a.lng
            };
        }
        if (bottomRight.lat > a.lat) {
            bottomRight = {
                ...bottomRight,
                lat: a.lat
            };
        }
    }
    return {
        center,
        topLeft,
        bottomRight,
        start
    };
}

export function getIXYBoundaries(points: IXY[]): {
    topLeft: IXY;
    width: number;
    height: number;
} {
    let topLeft: IXY = { x: Infinity, y: -Infinity };
    let bottomRight: IXY = { x: -Infinity, y: Infinity };
    for (const a of points) {
        if (topLeft.x > a.x) {
            topLeft = {
                ...topLeft,
                x: a.x
            };
        }
        if (topLeft.y < a.y) {
            topLeft = {
                ...topLeft,
                y: a.y
            };
        }
        if (bottomRight.x < a.x) {
            bottomRight = {
                ...bottomRight,
                x: a.x
            };
        }
        if (bottomRight.y > a.y) {
            bottomRight = {
                ...bottomRight,
                y: a.y
            };
        }
    }
    const width = Math.abs(bottomRight.x - topLeft.x);
    const height = Math.abs(bottomRight.y - topLeft.y);
    topLeft = {
        x: topLeft.x,
        y: bottomRight.y
    };
    return {
        topLeft,
        width,
        height
    };
}
